import { render, staticRenderFns } from "./SwitchBox.vue?vue&type=template&id=3bf8d752&scoped=true&"
import script from "./SwitchBox.vue?vue&type=script&lang=js&"
export * from "./SwitchBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf8d752",
  null
  
)

export default component.exports